import styled from '@emotion/styled';
import Help from '@material-ui/icons/Help';
import { ClassAttributes, createElement, ReactNode } from 'react';

import theme from '../../../theme';

type Props = ClassAttributes<HTMLElement> & {
  children: ReactNode;
  url: string;
  className?: string;
};

const HelpAnchor = ({ children, url, className }: Props) => (
  <Anchor href={url} target="_blank" rel="noopener noreferrer" className={className}>
    <HelpIcon />
    {children}
  </Anchor>
);

const Anchor = styled('a')({
  color: theme.palette.secondary.main,
  textDecoration: 'none',
});

const HelpIcon = styled(Help)({
  marginRight: '0.1rem',
  fontSize: '1.25rem',
  verticalAlign: 'text-top',
});

export default HelpAnchor;
